<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Resume Membership</h1>
        </template>
        
        <div>
            <p>Please confirm that you wish to resume your existing membership to the plan.</p>
        </div>

        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Resuming..."
                @click.native="submit"
            >
                Confirm
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        endpoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        async submit() {
            this.loading = true;
            axios.put(this.endpoint)
            .then(response => {
                this.$emit('resolve', response);
            })
            .catch(err => {
                console.error(err);
            }).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>